// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-AppProjects-AppProjects-module__container--2Q8Dg","addButton":"src-components-AppProjects-AppProjects-module__addButton--VNItp"};